module.exports = __webpack_public_path__ + "img/product_ljwx1.4561ab29.png";